import { data } from '../../svg/BillingAccount/data';
import { makeIcon } from '../makeIcon';

export const BillingAccount = makeIcon(data, 'billing_account', 'BillingAccount');

export default BillingAccount;
